import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const [viewers, setViewers] = useState(100);
  useEffect(() => {
    const startViewerCount = () => {
      let count = Math.floor(Math.random() * (120 - 80 + 1) + 80);
      setViewers(count);
      const interval = setInterval(() => {
        let increment = Math.floor(Math.random() * 3) - 1;
        count += increment;
        if (count < 60) count = 60;
        setViewers(count);
      }, 4500);
      return interval;
    };
    const interval = startViewerCount();
    return () => clearInterval(interval);
  }, []);
  return <section className="bg-[#111827] text-white py-[40px] px-[15px]" id="elige-tu-plan" data-id="element-183">
      <div className="container max-w-[1200px] mx-auto px-[15px]" data-id="element-184">
        <h2 className="text-[24px] text-center mb-[20px] font-[700] text-white font-['Montserrat']" data-id="element-185">
          Accedé a la Oferta Especial Hoy
        </h2>
        <p className="text-center text-white mx-auto mb-[30px] max-w-[600px]" data-id="element-186">
          Si estás cansado de tazas random y querés un sistema que te diga qué
          hacer cuando algo sale mal:
        </p>

        <div className="flex justify-center max-w-[550px] mx-auto mt-[20px]" data-id="element-187">
          <div className="border-[2px] border-[#8B4513] bg-gradient-to-br from-[#1f2937] to-[#000] p-[20px] rounded-[12px] text-center w-full" data-id="element-188">
            <div className="bg-gradient-to-br from-[#8B4513] to-[#D2B48C] text-white px-[20px] py-[6px] rounded-[50px] font-bold text-[13px] uppercase mb-[15px] inline-block" data-id="element-189">
              <Star className="inline w-[13px] h-[13px] mr-1" data-id="element-190" /> OFERTA LIMITADA
            </div>
            <h3 className="text-[24px] text-white font-[700] font-['Montserrat']" data-id="element-191">
              La Biblia del Café — Método BÍBLICO™
            </h3>
            <p className="text-[#ddd]" data-id="element-192">Sistema completo + Todos los Bonus</p>

            <div className="my-[12px]" data-id="element-193">
              <div className="text-[18px] line-through text-[#aaa]" data-id="element-194">$19.99</div>
              <div className="text-[44px] text-[#D2B48C] font-[800]" data-id="element-195">
                $6.37 USD
              </div>
            </div>

            <a href="https://www.oriammarketing.com/cart/45521167548614:1" onClick={() => trackAddToCart()} className="block w-full bg-gradient-to-br from-[#8B4513] to-[#A0522D] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(139,69,19,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(139,69,19,0.5)] transition-all duration-400" data-id="element-196">
              👉 DESCARGAR AHORA
            </a>
          </div>
        </div>

        <div className="max-w-[500px] mx-auto mt-[25px] mb-[10px] flex flex-col gap-[12px]" data-id="element-197">
          <div className="bg-[#111827] text-white font-[700] p-[12px] rounded-[8px] text-[16px] text-center" data-id="element-198">
            <strong data-id="element-199">
              <span className="viewer-count" data-id="element-200">{viewers}</span> personas
            </strong>{' '}
            están viendo esta oferta
          </div>
          <div className="bg-gradient-to-br from-[#EF4444] to-[#be123c] text-white font-[700] p-[12px] rounded-[8px] text-[16px] text-center flex items-center justify-center gap-[10px]" data-id="element-201">
            <span className="w-[12px] h-[12px] bg-white rounded-full animate-pulse-red" data-id="element-202"></span>{' '}
            ¡Últimos <strong data-id="element-203">5 Cupos</strong> en Oferta!
          </div>
        </div>

        <div className="text-center mt-[30px] text-[#ccc] text-[13px]" data-id="element-204">
          <p data-id="element-205">
            🔐 Pago 100% Seguro · ⚡ Acceso inmediato
            <br data-id="element-206" />
            💰 Sin cargos ocultos · ⏰ Oferta limitada
          </p>
        </div>
      </div>
    </section>;
}